import { EDC_PATHS, REQUEST_UNITS, REQUEST_VIEWS, requestViewPath } from "./edcPaths";

/**
 * Sidebar fallback for the distribution company portal while the EDC rows in
 * MNG_ModuleLists are inactive; once active, ModuleSideBar uses the UM menu instead.
 */
const item = (id, title, link) => ({ id, title, link, icon: id, level: 3 });

const requestItems = (unitKey) => [
  item(`edc-${unitKey}-dashboard`, "داشبورد", REQUEST_UNITS[unitKey].basePath),
  ...REQUEST_VIEWS.map((view) =>
    item(
      `edc-${unitKey}-${view.key}`,
      view.title,
      requestViewPath(unitKey, view.key)
    )
  ),
];

export const buildDistributionModuleMenuItems = ({
  pathname = "",
  canManageTeam = false,
} = {}) => {
  const section = String(pathname).toLowerCase().split("/").filter(Boolean)[1];

  if (section === "supervisors") return requestItems(REQUEST_UNITS.area.key);
  if (section === "engineering") return requestItems(REQUEST_UNITS.engineering.key);

  if (canManageTeam) {
    return [
      item("edc-management", "داشبورد مدیریت", EDC_PATHS.management),
      item("edc-areas", "امور", EDC_PATHS.areas),
      item("edc-substations", "ایستگاه‌های فوق توزیع", EDC_PATHS.substations),
      item("edc-feeders", "فیدرها", EDC_PATHS.feeders),
      item("edc-lvtrans", "ترانس‌های توزیع", EDC_PATHS.lvTrans),
      item("edc-users", "کاربران", EDC_PATHS.users),
      item("edc-supervisors", REQUEST_UNITS.area.title, REQUEST_UNITS.area.basePath),
      item("edc-engineering", REQUEST_UNITS.engineering.title, REQUEST_UNITS.engineering.basePath),
    ];
  }

  return [
    item("edc-supervisors", REQUEST_UNITS.area.title, REQUEST_UNITS.area.basePath),
    item("edc-engineering", REQUEST_UNITS.engineering.title, REQUEST_UNITS.engineering.basePath),
  ];
};

const normalizeDistributionPath = (pathname) =>
  String(pathname || "")
    .toLowerCase()
    .replace(/\/+$/, "");

/** Pages under /EDC/* that show the portal sidebar. */
export const isDistributionCompanyAreaPath = (pathname) =>
  normalizeDistributionPath(pathname).startsWith("/edc/");

/** Role-gated portal paths allowed while the EDC rows in MNG_ModuleLists are inactive. */
export const isDistributionPortalPath = (pathname) => {
  const p = normalizeDistributionPath(pathname);
  return (
    p === "/edc" ||
    p.startsWith("/edc/") ||
    p === "/sln/distributioncompany" ||
    p.startsWith("/sln/distributioncompany/")
  );
};
